import http from "@/shared/lib/utils/http";

export interface Features {
  signUpEnabled: boolean;
}

interface ListFeaturesResponse {
  sign_up: boolean;
}

let cachedFeatures: Features | null = null;

export async function getFeatures(): Promise<Features> {
  if (cachedFeatures) {
    return cachedFeatures;
  }

  try {
    const response = await http.get<ListFeaturesResponse>({
      url: "/features",
      contentType: "none",
    });

    cachedFeatures = { signUpEnabled: response.sign_up };
  } catch {
    // If the flags cannot be fetched, fall back to everything enabled. The UI
    // state is cosmetic only; the API remains the enforcement point and will
    // return 404 for disabled features regardless.
    return { signUpEnabled: true };
  }

  return cachedFeatures;
}
